module.exports = __webpack_public_path__ + "img/FR14506.7a8debe8.png";